module.exports = __webpack_public_path__ + "img/woocommerce.b984032d.png";